export const bottomMenuTracker = {
  actions: {
    createProject: 'Menu Inferior: Clicou em Criar projeto',
    equipmentBooking: 'Menu Inferior: Clicou em Reservar equipamentos',
    next: 'Menu Inferior: Clicou em Avançar',
    compareKits: 'Menu Inferior: Clicou em Comparar Kits',
  },
}
